import * as React from 'react';
import { Button, Card, CardActionArea, CardContent, CardHeader, CardMedia, Typography } from "@mui/material"
import { GitHub, Public } from '@mui/icons-material';
import { COLORS } from '../../constants/colors';

const Project = ({project}) =>{
    console.log(project);
    return(
        <>
        <Card style={{backgroundColor: COLORS.gray}}>
        <CardActionArea>
            <CardHeader style={{backgroundColor: COLORS.primary, color: COLORS.white, }}
            titleTypographyProps={{variant:'title' }}
            title={project.title}
            />
            <CardMedia style={{maxHeight: '100px'}}
            component="img"
            image={project.image}
            alt={project.title}
            />
            <CardContent>
            <Typography variant="body2">
                {project.description}
            </Typography>
            </CardContent>
            <div style={{display: 'flex', marginBottom: '10px', justifyContent:'space-around'}}>
                <Button style={{backgroundColor: '#000', color: '#fff' }}
                    disabled={!project.github}
                    component="a"
                    href={project.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<GitHub />}
                > GitHub </Button>
                <Button style={{backgroundColor: '#000', color: '#fff' }}
                    disabled={!project.url}
                    component="a"
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<Public />}
                > Live </Button>
                </div>
            </CardActionArea>
        </Card>
        </>
    )
}

export default Project;